var offsetTimezonePST = 480; //UTC-8
document.addEventListener('DOMContentLoaded', function() {
    //input datetime in PST MM/dd/yyyy hh:mm:ss AM/PM 
    var startDatePST = "11/20/2025 12:01:00 AM";
	var endDatePST = "12/01/2025 11:59:00 PM";
	var startCyberMondayDatePST = "11/30/2025 11:59:00 PM";
	countDownTimer(startDatePST, endDatePST, "leftDays", "leftHours", "leftMinutes", "leftSeconds", startCyberMondayDatePST); 

    //countDownTimer("11/3/2025 12:01:00 AM", "12/01/2025 11:59:00 PM", "leftDays", "leftHours", "leftMinutes", "leftSeconds", "11/12/2025 8:55:00 PM");     
    $(".videos button").each(function (){
        $(this).on('click', function (){
            var videoId= $(this).attr("aria-controls");
            var videoCtrl = $(this).parent("div").find("video[id='"+ videoId+"']");
            if(videoCtrl != null){
                $(this).find("span").each(function(index, element){
                    var innerImg = $(element).find("img").attr("src");
                    var hiddenSpan = $(element).attr("hidden");						
                    if(hiddenSpan != null){
                        $(element).removeAttr("hidden");
                        if(innerImg.indexOf("Pause") > 0){							
                            videoCtrl.get(0).play();
                        }else{
                            videoCtrl.get(0).pause();
                        }
                    }else{
                        $(element).attr("hidden", "");							
                    }                    
                });                
            }            
        });
    });

    $('.w-slider-mask').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: true,
    });
    /*----------------------------*/
    $('#choose-offer-top .inv-blackfri-choose-list').slick({
        swipe: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        arrows: false,
        infinite: false,
        responsive: [{
            breakpoint: 1200,
            settings: {
            swipe: true,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }, {
            breakpoint: 992,
            settings: {
            swipe: true,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }]
    });
    $('#choose-offer-top .slide-prev').click(function(e) {
        $('#choose-offer-top .inv-blackfri-choose-list').slick('slickPrev');
        $('#choose-offer-top .slide-next').show(); 
        var currentSlideIndex =  $('#choose-offer-top .inv-blackfri-choose-list').slick('slickCurrentSlide');
        if(currentSlideIndex == 0){
            $(this).hide();
        }
        
    });
    $('#choose-offer-top .slide-next').click(function(e) {
        $('#choose-offer-top .inv-blackfri-choose-list').slick('slickNext');
        $('#choose-offer-top .slide-prev').show();   

        var totalSlides =  $('#choose-offer-top .inv-blackfri-choose-list').slick('getSlick').$slides.length;
        var currentSlideIndex =  $('#choose-offer-top .inv-blackfri-choose-list').slick('slickCurrentSlide');   
        var slidesToShow = $('#choose-offer-top .inv-blackfri-choose-list').slick('slickGetOption', 'slidesToShow'); 
        if (currentSlideIndex + slidesToShow >= totalSlides) {
            $(this).hide();
        }
    });
    
    /*----------------------------*/
    $('#choose-offer-bottom .inv-blackfri-choose-list').slick({
        swipe: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        arrows: false,
        infinite: false,
        responsive: [{
            breakpoint: 1200,
            settings: {
            swipe: true,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }, {
            breakpoint: 992,
            settings: {
            swipe: true,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }]
    });
    $('#choose-offer-bottom .slide-prev').click(function(e) {
        $('#choose-offer-bottom .inv-blackfri-choose-list').slick('slickPrev');
        $('#choose-offer-bottom .slide-next').show();    

        var currentSlideIndex =   $('#choose-offer-bottom .inv-blackfri-choose-list').slick('slickCurrentSlide');
        if(currentSlideIndex == 0){
            $(this).hide();
        }   
    });
    $('#choose-offer-bottom .slide-next').click(function(e) {
        $('#choose-offer-bottom .inv-blackfri-choose-list').slick('slickNext');
        $('#choose-offer-bottom .slide-prev').show(); 

        var totalSlides = $('#choose-offer-bottom .inv-blackfri-choose-list').slick('getSlick').$slides.length;
        var currentSlideIndex = $('#choose-offer-bottom .inv-blackfri-choose-list').slick('slickCurrentSlide');   
        var slidesToShow = $('#choose-offer-bottom .inv-blackfri-choose-list').slick('slickGetOption', 'slidesToShow'); 
        if (currentSlideIndex + slidesToShow >= totalSlides) {
            $(this).hide();
        }      
    });

});


function countDownTimer(startDatePST, endDatePST, dayElement, hourElement, minuteElement, secondElement, startCyberMondayDatePST)
{
	var startPST = new Date(startDatePST);
    var endPST = new Date(endDatePST);
    var current = new Date(); 
	var currPST = current.getTimezoneOffset() == offsetTimezonePST ? current : toPST( current.getFullYear(), current.getMonth(), current.getDate(), current.getHours(), current.getMinutes(), current.getSeconds());
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer;

    function showRemaining() {      
        current = new Date(); 
        currPST = current.getTimezoneOffset() == offsetTimezonePST ? current : toPST( current.getFullYear(), current.getMonth(), current.getDate(), current.getHours(), current.getMinutes(), current.getSeconds());
        switchToCyberMondayPromo(currPST, startCyberMondayDatePST);
        var activeSection = getActivePromoSection();
        activeSection.querySelector(".inv-blackfri-countdown").classList.remove("d-none");
        activeSection.querySelector(".coming-soon").classList.add("d-none");

        var distance = endPST - currPST;
        if (distance < 0) {
            clearInterval(timer);
            activeSection.querySelector("." + dayElement).innerHTML = '0';
            activeSection.querySelector("." + hourElement).innerHTML = '0';
            activeSection.querySelector("." + minuteElement).innerHTML = '0';
            activeSection.querySelector("." + secondElement).innerHTML = '0';
            return;
        }
        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        activeSection.querySelector("." + dayElement).innerHTML = days;
        activeSection.querySelector("." + hourElement).innerHTML = hours;
        activeSection.querySelector("." + minuteElement).innerHTML = minutes;
        activeSection.querySelector("." + secondElement).innerHTML = seconds;       
    }
    if(currPST - startPST >= 0 &&  endPST - currPST >= 0){
        timer = setInterval(showRemaining, 1000);
    }else{
        var activeSection = getActivePromoSection();
        activeSection.querySelector(".inv-blackfri-countdown").classList.add("d-none");
        activeSection.querySelector(".coming-soon").classList.remove("d-none");    
    }
}

function toPST(year, month, day, hour, minute, second) {
	const date = new Date(Date.UTC(year, month, day, hour, minute, second));
	const offset = -8 * 60; // -8 hours * 60 minutes
	var pstDateTime = date;
	pstDateTime.setMinutes(date.getMinutes() + offset);
	const options = { timeZone: 'America/Los_Angeles' }; // Timezone to PST
	const formattedDateTime = pstDateTime.toLocaleString('en-US', options);
	//console.log("Timezone to PST: " + formattedDateTime);
	return new Date(formattedDateTime);
}

function switchToCyberMondayPromo(currPST, switchDatePST){
    var cyberMonday = document.getElementById("inv-cyber-top");

    if(cyberMonday.classList.contains("d-none") == true){
        var switchPST = new Date(switchDatePST);
        var distance = switchPST - currPST;
        if(distance <= 0){
            document.getElementById("inv-blackfri-top").classList.add("d-none");
            cyberMonday.classList.remove("d-none");
        }
    }
}

function getActivePromoSection(){
    var cyberMonday = document.getElementById("inv-cyber-top");
    var blackfri = document.getElementById("inv-blackfri-top");    
    return cyberMonday.classList.contains("d-none") == true ? blackfri : cyberMonday;
}
